/**
 * Fondo decorativo del Dashboard — gradient mesh animado con CSS puro.
 *
 * Tres blobs radiales con los colores del tenant (primary y accent),
 * blur fuerte, opacidad baja, animación lenta de translate que se
 * pausa con prefers-reduced-motion.
 *
 * Pure CSS, 0 JS, 0 dependencies. Pensado para sentarse detrás del
 * contenido del Dashboard sin interferir con clicks ni scroll.
 */
export default function DashboardBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="dashboard-backdrop pointer-events-none absolute -inset-6 overflow-hidden"
    >
      <div className="dashboard-backdrop__blob dashboard-backdrop__blob--primary" />
      <div className="dashboard-backdrop__blob dashboard-backdrop__blob--accent" />
      <div className="dashboard-backdrop__blob dashboard-backdrop__blob--mix" />
    </div>
  )
}
